export type Direction = 'column' | 'row' | 'table'

export interface ITextTemplateItem {
		index?: number | null
    id?: number | null
    text?: string
    maxLength?: number
    order?: number
    direction?: Direction
		column?: number
		lineHeight?: number
		fontSize?: number
		fontWeight?: number
		fontFamily?: string
		letterSpacing?: number
		color?: string
		safeArea?: number[]
    exampleUrl?: string
    templateUrl?: string
}

console.log('--加载state')
export default class PageState {
	//模板生成============================================================================
	self:any = null;
	title: string = "";
	//============================================================================
	// 微调编辑框是否获取焦点
	promtFocus = false
	// 字幕素材
	subtitleInfo = {
		fontColour: '#FFE001', // 字体颜色
		content: '请输入文字', // 字幕内容
		fontPercent: 8, // 新-字体大小 相对大小，相对视频高度 8%
		alpha: 1, // 字体透明度
		bgColor: '', // 背景颜色
		fontStrokeColor: '#000000', // 字体描边颜色
		fontStrokeWidth: 0.01, // 字体描边宽度
		bgMode: 'none', // 背景模式
		bgAlpha: 1, // 背景透明度
		type: 1, // 操作类型 1 正常赋值 2 撤销回退重新复制
		marginV: 0.1,
		marginL: 0.5,
		scale: 1,
		fontFamily: 'Douyin Sans',
		textList: [],
	}
	isHideBgMusic = false;
	// 文字模板列表
	defaultTextTemplateList = [];
	// 保存的文字模板列表
	savedTextList = [];
	// 保存的文字模板列表
	savedTextContent = {
		// 模板 id
		id: null,
		// 文字模板的文本
		text: '',
		// 素材宽度
		width: 0,
		// 素材高度
		height: 0,
		// 缩放比例
		scale: 1,
		// x 轴距离 %
		x: 0.04,
		// Y 轴距离 %
		y: 0.1
	};
	// 页面中正在操作的文本 index
	operatingTextIndex = null;
	// 正在操作的文字模板列表
	operatingTextList = [];
	// 页面中正在操作的文本内容 （未保存的）
	operatingTextContent = {
		// 模板 id
		id: null,
		// 文字模板的文本
		text: '',
		// 文本颜色
		color: '#ffffff',
		// 文本描边
		strokeColor: '',
		// 文本透明度
		opacity: 0.92,
		// 文本字体
		fontFamily: 'HarmonyOS_Sans_SC_Medium',
		// 文本背景色
		backgroundColor: '',
		// 文本字号大小
		fontSize: 14,
		// 素材宽度
		width: 0,
		// 素材高度
		height: 0,
		// 缩放比例
		scale: 1,
		// x 轴距离 %
		x: 0.04,
		// Y 轴距离 %
		y: 0.1
	};
	// 页面中正在操作的文字模板的数据 （样式...）
	operatingTextTemplateInfo = {
		// 素材 url
		url: '',
		start_time: 0,
		end_time: 0
	}
	// 保存上一次提交的水印模板信息
	oldTextTemplateInfo = {
		materialList: [],
		textTemplateList: [],
	}
	// 文章相关信息
	articleInfo = {
		// 文本id
		uniqueId: '',
		// 文章id
		articleId: '',
		// 文章配置
		extendVO: {},
		// 标题
		title: '',
		// 智能改写后的文案
		transformContent: ''
	}
	// 弹窗高度
	styleContentHeight = ''
	// 讲真是否显示
	isSwitch = true
	// 作品类别
	workType = ''
}
